import React, {useEffect, useState} from "react";
import axios from 'axios';
import Sectiontitle from "../components/Sectiontitle";
import Smalltitle from '../components/Smalltitle';
import Layout from "../components/Layout";
import Resume from "../components/Resume";
import {useTranslation} from "react-i18next";

function Cv(){
    const [information, setInformation] = useState("");
    const [workingExperience, setWorkingExperience] = useState([]);
    const [educationExperience, setEducationExperience] = useState([]);

    const {t} = useTranslation('common');

    useEffect(() =>{
        axios.get("/api/information").then((response) => {
            setInformation(response.data);
        });
        axios.get('/api/experience')
            .then(response =>{
                setWorkingExperience(response.data.workingExperience);
                setEducationExperience(response.data.educationExperience);
            })
    }, []);

    return (
        <Layout>
            <div className="mi-resume-area mi-section mi-padding-top mi-padding-bottom">
                <div className="container">
                    <Sectiontitle title="Curriculum vitae" />
                    <a rel="noopener noreferrer" href={t(information.cvfile)} target="_blank"
                       className="mi-button">
                        Download CV
                    </a>
                    <div className="mt-30"></div>
                    <Smalltitle title="cv.workexp" icon="briefcase" />
                    <div className="mi-resume-wrapper">
                        {workingExperience.map(workingExp => (
                            <Resume key={workingExp.id} resumeData={workingExp} />
                        ))}
                    </div>
                    <div className="mt-30"></div>
                    <Smalltitle title="cv.studies" icon="book" />
                    <div className="mi-resume-wrapper">
                        {educationExperience.map(educatonExp => (
                            <Resume key={educatonExp.id} resumeData={educatonExp}/>
                        ))}
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default Cv;
